const pixelToRem = (pixel: number, BASE: number = 16) => `${pixel / BASE}rem`

// keep this in sync with theme.d.ts
export const themeColor = {
  $pigmentGreen: '#00AD4F',
  $tangerineYellow: '#FFCC00',
  $darkOrange: '#FF9500',
  $outrageousRed: '#FA603F',
  $scienceBlue: '#0357d8',
  $dodgerBlue: '#007AFF',
  $sailBlue: '#99C9FF',
  $pureWhite: '#FFFFFF',
  $alabaster: '#F8F8F8',
  $whiteSmoke: '#EAEAEA',
  $silver: '#C3C3C3',
  $shadyLady: '#979797',
  $nightRider: '#303030',
  $pureBlack: '#000000',
  $paleSky: '#606e85',
  $copper: '#a38f84',
} as const

// keep this in sync with theme.d.ts
export const themeFontSize = {
  $h1: `${pixelToRem(21)}`,
  $h2: `${pixelToRem(16)}`,
  $h3: `${pixelToRem(15)}`,
  $h4: `${pixelToRem(13)}`,
  $h5: `${pixelToRem(13)}`,
  $h6: `${pixelToRem(13)}`,

  $p2: `${pixelToRem(14)}`,
  $p3: `${pixelToRem(12)}`,

  $xs: `${pixelToRem(8)}`,
  $s: `${pixelToRem(12)}`,
  $m: `${pixelToRem(14)}`,
  $l: `${pixelToRem(15)}`,
  $xl: `${pixelToRem(16)}`,
} as const

// keep this in sync with theme.d.ts
export const themeFontWeight = {
  $light: 400,
  $regular: 500,
  $semiBold: 600,
  $bold: 700,
} as const
